// This file is auto-generated by @hey-api/openapi-ts

import * as z from 'zod';

import type { Client, ClientMeta, Options as Options2, RequestResult, TDataShape } from './client';
import { client } from './client.gen';
import type { BackendVersionData, BackendVersionResponses, GetProminentB64Data, GetProminentB64Errors, GetProminentB64Responses, HealthData, HealthResponses } from './types.gen';
import { zGetProminentB64Body, zGetProminentB64Response } from './zod.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean, TResponse = unknown> = Options2<TData, ThrowOnError, TResponse> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: keyof ClientMeta extends never ? Record<string, unknown> : ClientMeta;
};

/**
 * Health
 */
export const health = <ThrowOnError extends boolean = false>(options?: Options<HealthData, ThrowOnError>): RequestResult<HealthResponses, unknown, ThrowOnError> => (options?.client ?? client).get<HealthResponses, unknown, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: z.never().optional(),
        query: z.never().optional()
    }).parseAsync(data),
    url: '/api/health',
    ...options
});

/**
 * Backend Version
 */
export const backendVersion = <ThrowOnError extends boolean = false>(options?: Options<BackendVersionData, ThrowOnError>): RequestResult<BackendVersionResponses, unknown, ThrowOnError> => (options?.client ?? client).get<BackendVersionResponses, unknown, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: z.never().optional(),
        query: z.never().optional()
    }).parseAsync(data),
    url: '/api/version',
    ...options
});

/**
 * Get Prominent B64
 */
export const getProminentB64 = <ThrowOnError extends boolean = false>(options: Options<GetProminentB64Data, ThrowOnError>): RequestResult<GetProminentB64Responses, GetProminentB64Errors, ThrowOnError> => (options.client ?? client).post<GetProminentB64Responses, GetProminentB64Errors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: zGetProminentB64Body,
        path: z.never().optional(),
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zGetProminentB64Response.parseAsync(data),
    url: '/api/get-prominent-b64',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
